import * as types from "./mutations.types";

export default {
  [types.SET_SHOW](state) {
    state.show = !state.show;
  },
  [types.SET_ITEM](state, payload) {
    state.item = payload;
  },
  [types.SET_IMAGES](state, payload) {
    state.images = payload;
  }
};
